export default __webpack_public_path__ + "static/uan-logo-ad4bd8ea4346537e143ca1c2e8a69f28.png";